"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.structureType = exports.structureByIdType = exports.dataType = void 0;
require("core-js/modules/es.symbol.description.js");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _equipments = require("./equipments");
var _constants = require("../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const structure = {
  [_constants.ComponentTypes.HtgCc]: _propTypes.default.arrayOf(_equipments.HtgCCItemType).isRequired,
  [_constants.ComponentTypes.HtgHs]: _propTypes.default.arrayOf(_equipments.HtgHsItemType).isRequired,
  [_constants.ComponentTypes.HtgHx]: _propTypes.default.arrayOf(_equipments.HtgHxItemType).isRequired,
  [_constants.ComponentTypes.HtgPipe]: _propTypes.default.arrayOf(_equipments.HtgPipeItemType).isRequired,
  [_constants.ComponentTypes.HtgSys]: _propTypes.default.arrayOf(_equipments.HtgSysItemType).isRequired,
  [_constants.ComponentTypes.HtgSub]: _propTypes.default.arrayOf(_equipments.HtgSubItemType).isRequired,
  [_constants.ComponentTypes.PwcPoe]: _propTypes.default.arrayOf(_equipments.PwcPoeItemType).isRequired,
  [_constants.ComponentTypes.PwhC]: _propTypes.default.arrayOf(_equipments.PwhCItemType).isRequired,
  [_constants.ComponentTypes.PwhPipe]: _propTypes.default.arrayOf(_equipments.PwhPipeItemType).isRequired,
  [_constants.ComponentTypes.PwhSupply]: _propTypes.default.arrayOf(_equipments.PwhSupplyItemType).isRequired
};
const structureType = exports.structureType = _propTypes.default.shape(_objectSpread({}, structure));
const structureByIdType = exports.structureByIdType = _propTypes.default.shape({
  [_constants.ComponentTypes.HtgCc]: _propTypes.default.shape({
    [_equipments.equipmentIdType]: _equipments.HtgCCItemType
  }).isRequired,
  [_constants.ComponentTypes.HtgHs]: _propTypes.default.shape({
    [_equipments.equipmentIdType]: _equipments.HtgHsItemType
  }).isRequired,
  [_constants.ComponentTypes.HtgHx]: _propTypes.default.shape({
    [_equipments.equipmentIdType]: _equipments.HtgHxItemType
  }).isRequired,
  [_constants.ComponentTypes.HtgPipe]: _propTypes.default.shape({
    [_equipments.equipmentIdType]: _equipments.HtgPipeItemType
  }).isRequired,
  [_constants.ComponentTypes.HtgSys]: _propTypes.default.shape({
    [_equipments.equipmentIdType]: _equipments.HtgSysItemType
  }).isRequired,
  [_constants.ComponentTypes.HtgSub]: _propTypes.default.shape({
    [_equipments.equipmentIdType]: _equipments.HtgSubItemType
  }).isRequired,
  [_constants.ComponentTypes.PwcPoe]: _propTypes.default.shape({
    [_equipments.equipmentIdType]: _equipments.PwcPoeItemType
  }).isRequired,
  [_constants.ComponentTypes.PwhC]: _propTypes.default.shape({
    [_equipments.equipmentIdType]: _equipments.PwhCItemType
  }).isRequired,
  [_constants.ComponentTypes.PwhPipe]: _propTypes.default.shape({
    [_equipments.equipmentIdType]: _equipments.PwhPipeItemType
  }).isRequired,
  [_constants.ComponentTypes.PwhSupply]: _propTypes.default.shape({
    [_equipments.equipmentIdType]: _equipments.PwhSupplyItemType
  }).isRequired
});
const dataType = exports.dataType = _propTypes.default.shape(_objectSpread({
  [_constants.ComponentTypes.Building]: _propTypes.default.arrayOf(_equipments.buildingItemType),
  [_constants.ComponentTypes.EdgeNode]: _propTypes.default.arrayOf(_equipments.edgeNodeItemType)
}, structure));